import { render, staticRenderFns } from "./ShopIntroPreview.vue?vue&type=template&id=c152a8bc&scoped=true"
import script from "./ShopIntroPreview.vue?vue&type=script&lang=js"
export * from "./ShopIntroPreview.vue?vue&type=script&lang=js"
import style0 from "./ShopIntroPreview.vue?vue&type=style&index=0&id=c152a8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c152a8bc",
  null
  
)

export default component.exports